var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"takt-journal-day t-shadow font-weight-light"},[_c('div',{staticClass:"takt-journal-day-overview white"},[_vm._t("overview")],2),_c('div',{staticClass:"takt-journal-day-content blue-grey lighten-5"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }